/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react'
import { useAlert } from 'react-alert'
import { useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'

import { IGridHeader } from '@components/UI/DataGrid'
import Icon from '@components/UI/Icon'
import { useCustomerList } from '@hooks/customer/useCustomer'
import { useDeleteUserById } from '@hooks/user/useUser'
import { ICustomerResponse } from '@resources/types/services/customer'

import PathRoutes from '@route/PathRoutes'
import { useCustomerActions } from '@store/customer'

const header: IGridHeader[] = [
  {
    label: 'Nome',
    grid: 3.5,
    action: null,
    value: 'name',
    field: 'values',
    styles: {
      align: 'left',
      fontType: undefined,
      fontSize: 14,
    },
  },
  {
    label: 'Email',
    grid: 4.5,
    action: null,
    value: 'email',
    field: 'values',
    styles: {
      align: 'left',
      fontType: undefined,
      fontSize: 13,
    },
  },
  {
    label: 'Documento',
    grid: 2.5,
    action: null,
    value: 'documento',
    field: 'values',
    styles: {
      align: 'left',
      fontType: undefined,
      fontSize: 13,
    },
  },
  {
    label: '',
    grid: 0.5,
    action: null,
    value: 'icon1',
    field: 'element',
    styles: {
      align: 'left',
      fontSize: 13,
    },
  },
  {
    label: '',
    grid: 0.5,
    action: null,
    value: 'icon2',
    field: 'element',
    styles: {
      align: 'left',
      fontSize: 13,
    },
  },
  {
    label: '',
    grid: 0.5,
    action: null,
    value: 'icon3',
    field: 'element',
    styles: {
      align: 'left',
      fontSize: 13,
    },
  },
]

export const useCustomerContainer = () => {
  const navigate = useNavigate()
  const alert = useAlert()
  const queryClient = useQueryClient()

  const { isError, data, isLoading, refetch } = useCustomerList()
  const { setCustomer } = useCustomerActions()
  const { mutate, isLoading: isLoadingDeleteUser } = useDeleteUserById()

  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [dataDeleteId, setDataDeleteId] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [userData, setUserData] = useState<ICustomerResponse | null>(null)

  const handleModal = () => {
    setShowModal(!showModal)
  }
  const handleUpdateModal = () => {
    setUserData(null)
  }

  const openUpdateModal = (data: ICustomerResponse) => {
    setUserData(data)
  }

  const handleCustomerNavigate = (customer: ICustomerResponse) => {
    setCustomer(customer)

    navigate(PathRoutes.backoffice.usersByCustomer.url)
  }

  const handleDeleteModal = (id = '') => {
    setDataDeleteId(id)
    setShowDeleteModal(!showDeleteModal)
  }

  const onSuccessDeleteUser = (): void => {
    alert.success('Cliente excluído com sucesso!')
    refetch()

    queryClient.invalidateQueries(['useCustomerList'])
  }
  const onErrorDeleteUser = (): void => {
    alert.error('Houve uma erro ao deletear o cliente.')
  }

  const fetchDeleteModal = () => {
    const deleteUserById = { uuid: dataDeleteId }
    mutate(deleteUserById, {
      onSuccess: onSuccessDeleteUser,
      onError: onErrorDeleteUser,
    })

    setShowDeleteModal(!showDeleteModal)
  }

  const handleData = () => {
    if (!data) return []

    const prepareData = data?.map((item) => {
      return {
        id: item.id.toString(),
        icon1: (
          <Icon
            name="FaUsers"
            onCallback={() => handleCustomerNavigate(item)}
          />
        ),
        icon2: (
          <Icon name="FaSearch" onCallback={() => openUpdateModal(item)} />
        ),
        icon3: (
          <Icon
            name="FaTrash"
            onCallback={() => handleDeleteModal(item.uuid)}
          />
        ),
        values: {
          name: item.name || item.tradingName,
          email: item.email,
          documento: item.document,
        },
      }
    })

    return prepareData
  }

  return {
    isError,
    isLoading,
    handleModal,
    showModal,
    header,
    handleData,
    userData,
    handleUpdateModal,
    showDeleteModal,
    handleDeleteModal,
    fetchDeleteModal,
    isLoadingDeleteUser,
  }
}
